<h2 mat-dialog-title>
    {{title}}
</h2>
<div mat-dialog-content>
    <p>{{message}}</p>
</div>
<div mat-dialog-actions class="d-flex justify-content-between">
    <button cdkFocusInitial (click)="onNoClick()" type="button" class="btn btn-reset">Nein</button>
    <button (click)="onYesClick()" cdkFocusInitial type="button" class="btn btn-primary w-50">Ja</button>
</div>
